export function getSelectedProjectData(selectedProjKeyNo, projects) {
    if (selectedProjKeyNo !== "" && projects && projects.length) {
        for (let i = 0; i < projects.length; i++) {
            if (projects[i].FME_PROJ_KEY_NO === selectedProjKeyNo) {
                return projects[i];
            }
        }
    }
    return null;
}

export function filterProjects(projects, searchText, city, county, region, act, mpo, congDistrict, houseDistrict, senateDistrict, phases, performance, years, type, admin, mapSelection, extent, mapped) {
    var filteredProjects = projects;
    var filters = [];
    if (searchText) {
        filteredProjects = filteredProjects.filter(project => 
            (project.FME_PROJ_NM && project.FME_PROJ_NM.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) || 
            (project.FME_PROJ_KEY_NO && project.FME_PROJ_KEY_NO.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) ||
            (project.FME_CITY && project.FME_CITY.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) ||
            (project.FME_COUNTY && project.FME_COUNTY.toLowerCase().indexOf(searchText.toLowerCase()) !== -1));
    }

    if (city || county || region || act || mpo || congDistrict || houseDistrict || senateDistrict) {
        filteredProjects = filteredProjects.filter(project => 
            (city && city.toLowerCase() === "bend" && project.FME_CITY && (project.FME_CITY.toLowerCase() === city.toLowerCase() || project.FME_CITY.toLowerCase().indexOf("bend,") === 0 || project.FME_CITY.toLowerCase().indexOf(",bend") !== -1))
            || (city && project.FME_CITY && project.FME_CITY.toLowerCase().indexOf(city.toLowerCase()) !== -1)
            || (county && project.FME_COUNTY && project.FME_COUNTY.toLowerCase().indexOf(county.toLowerCase()) !== -1)
            || (region && project.FME_REGION && project.FME_REGION.toLowerCase().indexOf(region.toLowerCase()) !== -1)
            || (act && project.FME_ACT && project.FME_ACT.toLowerCase().indexOf(act.toLowerCase()) !== -1)
            || (mpo && project.FME_MPO && project.FME_MPO.toLowerCase().indexOf(mpo.toLowerCase()) !== -1)
            || (congDistrict && project.FME_US_CNGR_DIST && project.FME_US_CNGR_DIST.toLowerCase().indexOf(congDistrict.toLowerCase()) !== -1)
            || (houseDistrict && project.FME_STATE_REP_DIST && project.FME_STATE_REP_DIST.toLowerCase().indexOf(houseDistrict.toLowerCase()) !== -1)
            || (senateDistrict && project.FME_STATE_SEN_DIST && project.FME_STATE_SEN_DIST.toLowerCase().indexOf(senateDistrict.toLowerCase()) !== -1));
    }
    if (phases && phases.length) {
        filters = filters.concat(phases);
        filteredProjects = filteredProjects.filter(project => project.FME_PHASE && filters.indexOf(project.FME_PHASE) !== -1);
    }
    if (performance && performance.length) {
        filteredProjects = filteredProjects.filter(project => (performance.includes("OnTime") && project.Late && project.Late === "FALSE")
            || (performance.includes("Late") && project.Late && project.Late === "TRUE")
            || (performance.includes("OnBudget") && project.OverBudget && project.OverBudget === "FALSE")
            || (performance.includes("OverBudget") && project.OverBudget && project.OverBudget === "TRUE"));
    }
    if (years && years.length) {
        filters = filters.concat(years);
        filteredProjects = filteredProjects.filter(project => project.FME_SCHED_YR && filters.indexOf(project.FME_SCHED_YR) !== -1);
    }
    if (type && type.length) {
        let typeFilteredProjects = [];
        for (let i = 0; i < type.length; i++) {
            typeFilteredProjects = typeFilteredProjects.concat(filteredProjects.filter(project => project.FME_PROJ_TYPE && project.FME_PROJ_TYPE.indexOf(type[i]) !== -1));
        }
        filteredProjects = typeFilteredProjects;
    }
    if(admin && admin.length) {
        let stipAdmins = [];
        for (let i = 0; i < admin.length; i++) {
            if (admin[i] === "LOCAL") {
                stipAdmins = stipAdmins.concat(["LOCAL", "LOCAL/CERT", "LOCAL/COBO", "LOCAL/SFLP"]);
            }
            else if (admin[i] === "ODOT") {
                stipAdmins = stipAdmins.concat(["MAINT", "ODOT", "ODOT/LOCAL", "RAIL", "TRANSIT"]);
            }
            else {
                stipAdmins.push(admin[i]);
            }

        }
        filters = filters.concat(stipAdmins);
        filteredProjects = filteredProjects.filter(project => filters.indexOf(project.STIP_ADMINISTRATOR_ID) !== -1);
    }
    if (mapSelection) {
        if (mapSelection.length) {
            filteredProjects = filteredProjects.filter(project => project.FME_PROJ_KEY_NO && mapSelection.indexOf(project.FME_PROJ_KEY_NO) !== -1); 
        }
        else if (mapSelection.length === 0 && extent) {
            filteredProjects = [];
        }
    }
    if (mapped && mapped.length) {
        filters = filters.concat(mapped); 
        filteredProjects = filteredProjects.filter(project => project.FME_MAPPED && filters.indexOf(project.FME_MAPPED) !== -1);
    }
    
    return filteredProjects;
}

export function removeDuplicates(originalArray, objKey) {
    var trimmedArray = [];
    var values = [];
    var value;
    if (originalArray) {
        for(var i = 0; i < originalArray.length; i++) {
            value = originalArray[i][objKey];
            if(values.indexOf(value) === -1) {
                trimmedArray.push(originalArray[i]);
                values.push(value);
            }
        }
    }

    return trimmedArray;
}

export function checkForFilters(filters) {
    let hasFilters = false;
    
    if(filters.search !== "") {
        hasFilters = true;
        return hasFilters;
    }
    for (var property in filters.location) {
        if (filters.location[property].selectedLocation !== "") {
            hasFilters = true;
            return hasFilters;
        }
    }
    if (filters.phase.length > 0) {
        hasFilters = true;
        return hasFilters;
    }
    if (filters.performance.length > 0) {
        hasFilters = true;
        return hasFilters;
    }
    if (filters.year.length > 0) {
        hasFilters = true;
        return hasFilters;
    }
    if (filters.type.length > 0) {
        hasFilters = true;
        return hasFilters;
    }
    if (filters.admin.length > 0) {
        hasFilters = true;
        return hasFilters;
    }
    if (filters.mapPoint !== "") {
        hasFilters = true;
        return hasFilters;
    }
    if (filters.mapped && filters.mapped.length > 0) {
        hasFilters = true;
        return hasFilters;
    }
    if (filters.extent) {
        hasFilters = true;
        return hasFilters;
    }
    
    return hasFilters;
}

export function compareFilters(urlFilters, filters) {
    let filtersDiffer = false;
    let updatedFilter = "";

    if (urlFilters.page !== filters.page && filters.page !== "")  {
        filtersDiffer = true;
        updatedFilter = "page";
    }
    if (urlFilters.search !== filters.search) {
        filtersDiffer = true;
        updatedFilter = "search";
    }
    for (let prop in urlFilters.location) {
        if (urlFilters.location[prop].selectedLocation !== filters.location[prop].selectedLocation) {
            filtersDiffer = true;
            updatedFilter = "location";
            break;
        }
    }
    if ((urlFilters.phase.length > 0 || filters.phase.length > 0) && urlFilters.phase.length !== filters.phase.length) {
        filtersDiffer = true;
        updatedFilter = "phase";
    }
    if ((urlFilters.performance.length > 0 || filters.performance.length > 0) && urlFilters.performance.length !== filters.performance.length) {
        filtersDiffer = true;
        updatedFilter = "performance";
    }
    if ((urlFilters.year.length > 0 || filters.year.length > 0) && urlFilters.year.length !== filters.year.length) {
        filtersDiffer = true;
        updatedFilter = "year";
    }
    if ((urlFilters.type.length > 0 || filters.type.length > 0) && urlFilters.type.length !== filters.type.length) {
        filtersDiffer = true;
        updatedFilter = "type";
    }
    if ((urlFilters.admin.length > 0 || filters.admin.length > 0) && urlFilters.admin.length !== filters.admin.length) {
        filtersDiffer = true;
        updatedFilter = "admin";
    }
    if ((urlFilters.map.length > 0 || filters.map.length > 0) && (urlFilters.map.length !== filters.map.length || urlFilters.mapPoint !== filters.mapPoint)) {
        filtersDiffer = true;
        updatedFilter = "map";
    }
    if (urlFilters.mapPoint !== filters.mapPoint) {
        filtersDiffer = true;
        if(urlFilters.mapPoint === "") {
            updatedFilter = "removedMapPoint";
        }
        else {
            updatedFilter = "urlAddedMapPoint";
        }
    }
    if (urlFilters.selectedForSnapshot !== filters.selectedForSnapshot) {
        filtersDiffer = true;
        updatedFilter = "snapshot";
    }
    if ((urlFilters.mapped.length > 0 || filters.mapped.length > 0) && urlFilters.mapped.length !== filters.mapped.length) {
        filtersDiffer = true;
        updatedFilter = "mapped";
    }

    return {filtersDiffer, updatedFilter}

}

export function updateHistory(history, newFilters) {
    let path = newFilters.page === "home" ? "" : "/projects";
    let searchParams = "";
    
    searchParams += newFilters.search ? "search=" + newFilters.search + "&" : "";
    for (const property in newFilters.location) {
        searchParams += newFilters.location[property].selectedLocation ? newFilters.location[property].name + "=" + newFilters.location[property].selectedLocation + "&" : "";
    }
    searchParams += newFilters.phase.length ? "phase=" + newFilters.phase.join(';') + "&" : "";
    searchParams += newFilters.performance.length ? "performance=" + newFilters.performance.join(';') + "&" : "";
    searchParams += newFilters.year.length ? "year=" + newFilters.year.join(';') + "&" : "";
    searchParams += newFilters.type.length ? "type=" + newFilters.type.join(';') + "&" : "";
    searchParams += newFilters.admin.length ? "admin=" + newFilters.admin.join(';') + "&" : "";
    searchParams += newFilters.map.length ? "map=" + newFilters.map.join(';') + "&" : "";
    searchParams += newFilters.mapPoint ? "mapPoint=" + newFilters.mapPoint + "&" : "";
    searchParams += newFilters.mapped.length ? "mapped=" + newFilters.mapped.join(';') + "&" : "";

    if (newFilters.selectedForSnapshot.length) {
        path += "/" + newFilters.selectedForSnapshot;
    }
    
    if (searchParams.length > 0) {
        path += "?" + searchParams.substring(0, searchParams.length - 1);
    }
    
    history.push(path);
}

export function updatePathname(history, selectedProject) {
    let path = '/projects/';
    
    path += selectedProject + window.location.search;
    history.push(path);
}